import styled from 'styled-components';
import { BLACK, GRAYSCALE_200, GRAYSCALE_500, NEUTRAL_100, WHITE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

interface BodyContainerProps {
  $hasData: boolean;
}

interface FooterContainerProps {
  $hasData: boolean;
}

interface TextProps {
  $hasData: boolean;
}

export const Container = (styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 1;
  background: #4B1EB9;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const BackgroundContainer = (styled.div`
  position: absolute;
  top: -25%;
  left: -25%;
  z-index: 1;
  transform: scale(2);
  transform-origin: center center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const BodyContainer = (styled.div<BodyContainerProps>`
  background-color: ${({ $hasData }) => $hasData ? WHITE : 'transparent'};
  border: ${({ $hasData }) => $hasData ? `1px solid ${NEUTRAL_100}` : 'none'};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 12px;
  z-index: 2;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ParticlesContainer = (styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TextContainer = (styled.div<TextProps>`
  color: ${({ $hasData }) => $hasData ? BLACK : WHITE};
  display: flex;
  flex-direction: column;
  width: 95%;
  gap: 4px;
  font-family: ${INTER.regular};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TitleText = (styled.span`
  font-family: ${INTER.bold};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SubtitleText = (styled.span<TextProps>`
  color: ${({ $hasData }) => $hasData ? GRAYSCALE_500 : GRAYSCALE_200};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const FooterContainer = (styled.div<FooterContainerProps>`
  background-color: ${({ $hasData }) => $hasData ? 'transparent' : WHITE};
  border: ${({ $hasData }) => $hasData ? 'none' : `1px solid ${NEUTRAL_100}`};
  cursor: pointer;
  padding: 16px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  color: ${({ $hasData }) => $hasData ? WHITE : BLACK};
  font-family: ${INTER.regular};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
